var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "div",
    _vm._g(
      _vm._b(
        {
          ref: _vm.data.ref,
          staticClass:
            "animate__animated animate__fadeIn animate__faster stick-all-corners",
          class: _vm.$style.wrapper
        },
        "div",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }